import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import logo_pink from '../assets/effie-logo3b-new-white.svg';

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    emailjs.init("2eVF5SOiiREDAxW0F");
  }, []);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) {
      alert("Please enter your email address");
      return;
    }

    setIsSubmitting(true);

    const templateParams = {
      email: email,
    };

    emailjs
      .send(
        "service_jity3va",
        "template_3fs6jug",
        templateParams
      )
      .then(
        (response) => {
          alert("Subscribed successfully!");
          setEmail("");
          setIsSubmitting(false);
        },
        (error) => {
          alert("Failed to subscribe. Please try again later.");
          console.error("EmailJS Error:", error);
          setIsSubmitting(false);
        }
      );
  };

  return (
    <footer className="bg-sky-800 text-white py-12">
      <div className="container flex flex-col mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="">
            <div className="flex justify-center items-center">
              <a href="/" className="text-2xl font-bold">
                <img className="h-10" src={logo_pink} alt="Effie Logo" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-4">Stay Updated</h3>
            <p className="mb-4 text-lg">
              Would you like to stay informed on recent developments in Generative AI?
            </p>
            <form className="flex flex-col space-y-4">
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="p-3 rounded bg-white text-sky-800 text-lg focus:ring-2 focus:ring-deep-terracotta"
              />
              <button
                type="submit"
                onClick={handleSubscribe}
                disabled={isSubmitting}
                className={`bg-deep-terracotta text-white text-lg font-medium py-2 px-4 rounded hover:bg-[#9f32b2]/90 transition-all ${
                  isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                {isSubmitting ? "Subscribing..." : "Subscribe"}
              </button>
            </form>
          </div>

          <div className="flex flex-col justify-center items-center">
            <h3 className="text-xl font-semibold mb-4">Connect with Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/ai.effie"
                className="text-white hover:text-deep-terracotta transition-all"
              >
                <FaFacebook size={24} />
              </a>
              <a
                href="https://instagram.com/ai.effie"
                className="text-white hover:text-deep-terracotta transition-all"
              >
                <FaTwitter size={24} />
              </a>
              <a
                href="https://linkedin.com/company/effie-ai"
                className="text-white hover:text-deep-terracotta transition-all"
              >
                <FaLinkedin size={24} />
              </a>
              <a
                href="https://instagram.com/ai.effie"
                className="text-white hover:text-deep-terracotta transition-all"
              >
                <FaInstagram size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center text-lg border-t border-white/20 pt-6">
          © {new Date().getFullYear()}{" "}
          <a
            href="https://dataspeckle.com"
            className="text-white no-underline hover:text-sky-300"
          >
            DataSpeckle Scientific.
          </a>{" "}
          All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;